module.exports = __webpack_public_path__ + "img/top1.016c3b01.png";